export default __webpack_public_path__ + "static/media/femme_dos.511c921e.jpg";